import api from './api';

// The canonical folio payload for one reservation.
//
// This is the same JSON an OHIP folio row carries in its `payload` column — the
// `reservationFolioInformation` shape of canonical group 2 — except that for an OperaV5 vault nothing
// stored it: the extract holds Opera's raw tables, so it is assembled on demand from them by the
// vault-folio-build lambda. Both vault types therefore hand the folio template the same object, which is
// what lets one template, one detail modal and one Payload view serve every PMS.
//
// KEYED ON THE RESERVATION ID — the `reservationid` column of the folio row. Deliberately not
// RESV_NAME_ID: which internal key a PMS uses to find a reservation is the backend's business, and a
// screen that knew it would need a branch per PMS.
//
// WHICH FIELD, AND WHICH PROPERTY, ARE BOTH SENT. A vault holds several hotels and their id spaces
// overlap — CHEWTON's reservation 1467369 and CLIVEDEN's confirmation 1467369 are different stays. Sending
// the id alone let the backend match either field and return the wrong hotel's folio, complete and
// convincing. `confirmation_no` is a separate argument for a caller that holds one.
// Render a composed folio to a real PDF.
//
// SERVER-SIDE, because the only way to get a PDF that matches the hotel's own template is to use the
// engine the template was designed against. The lambda runs headless Chromium — the same renderer
// behind the Print button — so what is downloaded is what the Print preview shows, with the text still
// selectable and searchable. A client-side library would rasterise it into a picture of an invoice.
//
// The composed HTML is sent, not the row: the portal already holds the template, the row and the
// payload and builds exactly what Print shows. Re-resolving that server-side would be a second renderer
// to keep in step with the first.
const renderFolioPdf = async (html, filename) => {
    const response = await api.post('/vault/folio-pdf', { html, filename });
    return response.data;
};

const vaultFolioService = {
    // folioNo / folioWindowNo name the bill that was clicked, so the document is that folio rather than
    // the reservation's lowest window (HIL-7).
    build: async (vaultId, { reservationId, confirmationNo, resort, folioNo, folioWindowNo } = {}) => {
        const response = await api.post('/vault-folio-build', {
            vault_id: Number(vaultId),
            ...(reservationId ? { reservation_id: reservationId } : {}),
            ...(!reservationId && confirmationNo ? { confirmation_no: confirmationNo } : {}),
            ...(resort ? { resort } : {}),
            ...(folioNo ? { folio_no: folioNo } : {}),
            ...(folioWindowNo ? { folio_window_no: folioWindowNo } : {}),
        });
        return response.data;
    },

    search: async (vaultId, params = {}) => {
        const response = await api.get('/vault-folio-search', { params: { vault_id: Number(vaultId), ...params } });
        return response.data;
    },
};

export { renderFolioPdf };
export default vaultFolioService;
